import React from 'react';

interface SkeletonLineProps {
  width?: number | string;
  height?: number;
  className?: string;
}

interface ShipmentTableSkeletonCellProps {
  columnIndex: number;
}

const SkeletonLine: React.FC<SkeletonLineProps> = ({
  width = '70%',
  height = 10,
  className,
}) => (
  <span
    className={`shipment-grid-skeleton-line${className ? ` ${className}` : ''}`}
    style={{
      width,
      height,
    }}
  />
);

const ShipmentTableSkeletonCell: React.FC<ShipmentTableSkeletonCellProps> = ({
  columnIndex,
}) => {
  if (columnIndex === 0) {
    return (
      <div className='shipment-grid-skeleton-cell shipment-grid-skeleton-reference-cell'>
        <SkeletonLine width='86%' height={14} />
        <SkeletonLine
          width={76}
          height={14}
          className='shipment-grid-skeleton-pill'
        />
      </div>
    );
  }

  if (columnIndex === 1) {
    return (
      <div className='shipment-grid-skeleton-cell shipment-grid-skeleton-tracking-cell'>
        <div className='shipment-grid-skeleton-status-row'>
          <SkeletonLine width='38%' height={12} />
          <SkeletonLine
            width={64}
            height={20}
            className='shipment-grid-skeleton-pill'
          />
        </div>
        <SkeletonLine width='82%' height={10} />
        <div className='shipment-grid-skeleton-stage-row'>
          <SkeletonLine width={46} height={4} />
          <SkeletonLine width={46} height={4} />
          <SkeletonLine width={46} height={4} />
          <SkeletonLine width={46} height={4} />
          <SkeletonLine width={46} height={4} />
        </div>
      </div>
    );
  }

  if (columnIndex === 2 || columnIndex === 3) {
    return (
      <div className='shipment-grid-skeleton-cell shipment-grid-skeleton-location-cell'>
        <SkeletonLine width='68%' height={12} />
        <SkeletonLine width='92%' height={10} />
        <SkeletonLine width='54%' height={8} />
      </div>
    );
  }

  if (columnIndex === 4) {
    return (
      <div className='shipment-grid-skeleton-cell shipment-grid-product-skeleton-cell'>
        <SkeletonLine width='64%' height={11} />
      </div>
    );
  }

  return (
    <div className='shipment-grid-skeleton-cell shipment-grid-skeleton-plain-cell'>
      <SkeletonLine width={columnIndex % 2 === 0 ? '62%' : '74%'} height={11} />
    </div>
  );
};

export default ShipmentTableSkeletonCell;
